import {
  Component,
  OnInit,
  Inject,
  PLATFORM_ID
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { ChangePasswordService } from '../../../Authentication/auth/change-password.service';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
})
export class ChangePasswordComponent implements OnInit {

  contentReady = false;
  changePasswordForm!: FormGroup;
  isAr = false;
  isPasswordVisible = false;

  private isBrowser: boolean;

  constructor(
    private _FormBuilder: FormBuilder,
    private _changePasswordService: ChangePasswordService,
    private _router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit(): void {

    // language → browser only
    if (this.isBrowser) {
      this.isAr = localStorage.getItem('language') === 'ar';
    }

    this.changePasswordForm = this._FormBuilder.group(
      {
        old_password: ['', Validators.required],
        new_password: ['', Validators.required],
        new_password_confirmation: ['', Validators.required],
      },
      {
        validator: this.validateAreEqual(
          'new_password',
          'new_password_confirmation'
        )
      }
    );
  }

  // ================= SUBMIT =================
  onSubmit(): void {
    if (!this.changePasswordForm.valid) return;

    this.contentReady = true;

    const { old_password, new_password, new_password_confirmation } =
      this.changePasswordForm.value;

    this._changePasswordService
      .resetPassword(
        old_password,
        new_password,
        new_password_confirmation
      )
      .subscribe({
        next: () => {
          this.contentReady = false;
          Swal.fire({
            icon: 'success',
            title: this.isAr ? 'كلمة السر اتغيرت' : 'Password changed',
            showConfirmButton: false,
            timer: 1500,
          });
          this._router.navigateByUrl('/Profile');
        },
        error: () => {
          this.contentReady = false;
          Swal.fire({
            icon: 'error',
            title: this.isAr
              ? 'البيانات اللي مدخلها فيها حاجة غلط'
              : 'Wrong password',
            confirmButtonText: this.isAr ? 'تمام' : 'OK',
          });
        },
      });
  }

  // ================= UI =================
  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  // ================= VALIDATION =================
  validateAreEqual(pass: string, confirmPass: string) {
    return (group: FormGroup) => {
      const password = group.controls[pass];
      const confirmation = group.controls[confirmPass];

      if (password.value !== confirmation.value) {
        confirmation.setErrors({ passwordMismatch: true });
      } else {
        confirmation.setErrors(null);
      }
    };
  }
}
